import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Cross = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M12 13.4143L16.5426 17.9569C16.5426 17.9569 16.5428 17.9572 17.25 17.2501C17.9571 16.543 17.957 16.5429 17.957 16.5429L13.4142 12.0001L17.9571 7.45718L16.5428 6.04297L12 10.5859L7.45706 6.04297L6.04285 7.45718L10.5857 12.0001L6.04285 16.543L7.45706 17.9572L12 13.4143Z"
      fill="currentColor"
    />
  </Icon>
));

export default Cross;
